import { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLookupData } from '../../cinnamon-core/es/modules/lookups/selectors.js';
import { compareParams } from '../../cinnamon-core/es/modules/utility/params.js';
import { lookupRequest } from '../../cinnamon-core/es/modules/lookups/actions.js';

var DEFAULT_LOOKUP_DATA = {
  loading: false,
  slowLoading: false
};

var useInputLookupData = function useInputLookupData(lookup, lookupParams, lookupOptions, canRequestData) {
  var dispatch = useDispatch();
  var requestRequired = useRef(true);
  var lookupData = useSelector(function (state) {
    return lookup ? getLookupData(state, lookup, lookupParams, lookupOptions) : DEFAULT_LOOKUP_DATA;
  });
  var prevLookupState = useRef({
    lookup: lookup,
    lookupData: lookupData,
    lookupParams: lookupParams
  });
  useEffect(function () {
    // re-request if lookup was reset, params changed, or was flagged
    var dataInvalid = canRequestData && requestRequired.current || lookup !== prevLookupState.current.lookup || !lookupData.date && prevLookupState.current.lookupData.date || !compareParams(lookupParams, prevLookupState.current.lookupParams);
    prevLookupState.current = {
      lookup: lookup,
      lookupData: lookupData,
      lookupParams: lookupParams
    };
    if (!lookup || !dataInvalid) return;

    if (!canRequestData) {
      // flag that lookup data should be retrieved when the component is re-enabled
      requestRequired.current = true;
      return;
    }

    requestRequired.current = false;
    dispatch(lookupRequest(lookup, lookupParams, lookupOptions));
  }, [lookup, lookupData, lookupParams, lookupOptions, dispatch, lookupRequest, canRequestData]);
  return lookupData;
};

var useInputLookupData$1 = useInputLookupData;

export { useInputLookupData$1 as default };
